import { render, staticRenderFns } from "./listPageAuthorization.vue?vue&type=template&id=1443c22f&"
import script from "./listPageAuthorization.vue?vue&type=script&lang=js&"
export * from "./listPageAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./listPageAuthorization.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1443c22f')) {
      api.createRecord('1443c22f', component.options)
    } else {
      api.reload('1443c22f', component.options)
    }
    module.hot.accept("./listPageAuthorization.vue?vue&type=template&id=1443c22f&", function () {
      api.rerender('1443c22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/data_auth/list_page_authorization/listPageAuthorization.vue"
export default component.exports